import { render, staticRenderFns } from "./ModalCreateSupplier.vue?vue&type=template&id=662f4e28&scoped=true&"
import script from "./ModalCreateSupplier.vue?vue&type=script&lang=js&"
export * from "./ModalCreateSupplier.vue?vue&type=script&lang=js&"
import style0 from "./ModalCreateSupplier.vue?vue&type=style&index=0&id=662f4e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662f4e28",
  null
  
)

export default component.exports